/* tslint:disable */
/* eslint-disable */
/**
 * Hisselab.Score.StockFilter.Query
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface Any
 */
export interface Any {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof Any
     */
    '@type': string;
}
/**
 * 
 * @export
 * @interface BetweenOperator
 */
export interface BetweenOperator {
    /**
     * 
     * @type {GteOperator}
     * @memberof BetweenOperator
     */
    'gte'?: GteOperator;
    /**
     * 
     * @type {LteOperator}
     * @memberof BetweenOperator
     */
    'lte'?: LteOperator;
}
/**
 * 
 * @export
 * @interface BetweenOperatorValue
 */
export interface BetweenOperatorValue {
    /**
     * 
     * @type {GteOperatorValue}
     * @memberof BetweenOperatorValue
     */
    'gte'?: GteOperatorValue;
    /**
     * 
     * @type {LteOperatorValue}
     * @memberof BetweenOperatorValue
     */
    'lte'?: LteOperatorValue;
}
/**
 * 
 * @export
 * @interface ColumnName
 */
export interface ColumnName {
    /**
     * 
     * @type {string}
     * @memberof ColumnName
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof ColumnName
     */
    'dataId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ColumnName
     */
    'order'?: number;
}
/**
 * 
 * @export
 * @interface DeleteReplay
 */
export interface DeleteReplay {
    /**
     * 
     * @type {number}
     * @memberof DeleteReplay
     */
    'deletedCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof DeleteReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface FetchReplay
 */
export interface FetchReplay {
    /**
     * 
     * @type {Array<Snapshot>}
     * @memberof FetchReplay
     */
    'Items'?: Array<Snapshot>;
    /**
     * 
     * @type {Array<ColumnName>}
     * @memberof FetchReplay
     */
    'columns'?: Array<ColumnName>;
    /**
     * 
     * @type {string}
     * @memberof FetchReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface FetchRequest
 */
export interface FetchRequest {
    /**
     * 
     * @type {string}
     * @memberof FetchRequest
     */
    'culture'?: string;
    /**
     * 
     * @type {ScreenerFilter}
     * @memberof FetchRequest
     */
    'fieldFilter'?: ScreenerFilter;
    /**
     * 
     * @type {ScopeFilter}
     * @memberof FetchRequest
     */
    'scopeFilter'?: ScopeFilter;
    /**
     * 
     * @type {boolean}
     * @memberof FetchRequest
     */
    'showFinancial'?: boolean;
}
/**
 * 
 * @export
 * @interface FieldData
 */
export interface FieldData {
    /**
     * 
     * @type {number}
     * @memberof FieldData
     */
    'dataId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FieldData
     */
    'value'?: number;
}
/**
 * 
 * @export
 * @interface Filter
 */
export interface Filter {
    /**
     * 
     * @type {number}
     * @memberof Filter
     */
    'screenerId'?: number;
    /**
     * 
     * @type {GteOperator}
     * @memberof Filter
     */
    'gte'?: GteOperator;
    /**
     * 
     * @type {LteOperator}
     * @memberof Filter
     */
    'lte'?: LteOperator;
    /**
     * 
     * @type {BetweenOperator}
     * @memberof Filter
     */
    'between'?: BetweenOperator;
    /**
     * 
     * @type {object}
     * @memberof Filter
     */
    'empty'?: object;
}
/**
 * 
 * @export
 * @interface FilterInfo
 */
export interface FilterInfo {
    /**
     * 
     * @type {number}
     * @memberof FilterInfo
     */
    'screenerId'?: number;
    /**
     * 
     * @type {MName}
     * @memberof FilterInfo
     */
    'scrennerName'?: MName;
    /**
     * 
     * @type {GteOperatorValue}
     * @memberof FilterInfo
     */
    'gte'?: GteOperatorValue;
    /**
     * 
     * @type {LteOperatorValue}
     * @memberof FilterInfo
     */
    'lte'?: LteOperatorValue;
    /**
     * 
     * @type {BetweenOperatorValue}
     * @memberof FilterInfo
     */
    'between'?: BetweenOperatorValue;
    /**
     * 
     * @type {object}
     * @memberof FilterInfo
     */
    'empty'?: object;
}
/**
 * 
 * @export
 * @interface GteOperator
 */
export interface GteOperator {
    /**
     * 
     * @type {number}
     * @memberof GteOperator
     */
    'value'?: number;
}
/**
 * 
 * @export
 * @interface GteOperatorValue
 */
export interface GteOperatorValue {
    /**
     * 
     * @type {number}
     * @memberof GteOperatorValue
     */
    'value'?: number;
}
/**
 * 
 * @export
 * @interface ListItemInfo
 */
export interface ListItemInfo {
    /**
     * 
     * @type {boolean}
     * @memberof ListItemInfo
     */
    'system'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ListItemInfo
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ListItemInfo
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof ListItemInfo
     */
    'order'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ListItemInfo
     */
    'criteriaPanelShow'?: boolean;
    /**
     * 
     * @type {Array<FilterInfo>}
     * @memberof ListItemInfo
     */
    'filters'?: Array<FilterInfo>;
}
/**
 * 
 * @export
 * @interface ListReplay
 */
export interface ListReplay {
    /**
     * 
     * @type {string}
     * @memberof ListReplay
     */
    'error'?: string;
    /**
     * 
     * @type {Array<ListItemInfo>}
     * @memberof ListReplay
     */
    'items'?: Array<ListItemInfo>;
}
/**
 * 
 * @export
 * @interface LteOperator
 */
export interface LteOperator {
    /**
     * 
     * @type {number}
     * @memberof LteOperator
     */
    'value'?: number;
}
/**
 * 
 * @export
 * @interface LteOperatorValue
 */
export interface LteOperatorValue {
    /**
     * 
     * @type {number}
     * @memberof LteOperatorValue
     */
    'value'?: number;
}
/**
 * 
 * @export
 * @interface MName
 */
export interface MName {
    /**
     * 
     * @type {string}
     * @memberof MName
     */
    'trTR'?: string;
    /**
     * 
     * @type {string}
     * @memberof MName
     */
    'enUS'?: string;
}
/**
 * 
 * @export
 * @interface NewReplay
 */
export interface NewReplay {
    /**
     * 
     * @type {string}
     * @memberof NewReplay
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof NewReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface NewRequest
 */
export interface NewRequest {
    /**
     * 
     * @type {string}
     * @memberof NewRequest
     */
    'name'?: string;
    /**
     * 
     * @type {Array<FilterInfo>}
     * @memberof NewRequest
     */
    'filters'?: Array<FilterInfo>;
}
/**
 * 
 * @export
 * @interface RenameReplay
 */
export interface RenameReplay {
    /**
     * 
     * @type {number}
     * @memberof RenameReplay
     */
    'modifiedCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof RenameReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface ScopeFilter
 */
export interface ScopeFilter {
    /**
     * 
     * @type {string}
     * @memberof ScopeFilter
     */
    'constituentEntityId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ScopeFilter
     */
    'watchlistId'?: string;
    /**
     * 
     * @type {number}
     * @memberof ScopeFilter
     */
    'sourceDataId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ScopeFilter
     */
    'currencyDataId'?: number;
}
/**
 * 
 * @export
 * @interface ScreenerCategoryInfo
 */
export interface ScreenerCategoryInfo {
    /**
     * 
     * @type {number}
     * @memberof ScreenerCategoryInfo
     */
    'dataId'?: number;
    /**
     * 
     * @type {MName}
     * @memberof ScreenerCategoryInfo
     */
    'name'?: MName;
    /**
     * 
     * @type {Array<ScreenerFieldInfo>}
     * @memberof ScreenerCategoryInfo
     */
    'fields'?: Array<ScreenerFieldInfo>;
}
/**
 * 
 * @export
 * @interface ScreenerCategoryListReplay
 */
export interface ScreenerCategoryListReplay {
    /**
     * 
     * @type {string}
     * @memberof ScreenerCategoryListReplay
     */
    'error'?: string;
    /**
     * 
     * @type {Array<ScreenerCategoryInfo>}
     * @memberof ScreenerCategoryListReplay
     */
    'categories'?: Array<ScreenerCategoryInfo>;
}
/**
 * 
 * @export
 * @interface ScreenerFieldInfo
 */
export interface ScreenerFieldInfo {
    /**
     * 
     * @type {number}
     * @memberof ScreenerFieldInfo
     */
    'dataId'?: number;
    /**
     * 
     * @type {MName}
     * @memberof ScreenerFieldInfo
     */
    'name'?: MName;
}
/**
 * 
 * @export
 * @interface ScreenerFilter
 */
export interface ScreenerFilter {
    /**
     * 
     * @type {Array<Filter>}
     * @memberof ScreenerFilter
     */
    'items'?: Array<Filter>;
}
/**
 * 
 * @export
 * @interface Snapshot
 */
export interface Snapshot {
    /**
     * 
     * @type {number}
     * @memberof Snapshot
     */
    'sourceId'?: number;
    /**
     * 
     * @type {number}
     * @memberof Snapshot
     */
    'securityId'?: number;
    /**
     * 
     * @type {string}
     * @memberof Snapshot
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof Snapshot
     */
    'uniqueCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof Snapshot
     */
    'name'?: string;
    /**
     * 
     * @type {Array<FieldData>}
     * @memberof Snapshot
     */
    'Fields'?: Array<FieldData>;
}
/**
 * 
 * @export
 * @interface Status
 */
export interface Status {
    /**
     * 
     * @type {number}
     * @memberof Status
     */
    'code'?: number;
    /**
     * 
     * @type {string}
     * @memberof Status
     */
    'message'?: string;
    /**
     * 
     * @type {Array<Any>}
     * @memberof Status
     */
    'details'?: Array<Any>;
}
/**
 * 
 * @export
 * @interface SyncReplay
 */
export interface SyncReplay {
    /**
     * 
     * @type {number}
     * @memberof SyncReplay
     */
    'modifiedCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof SyncReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface SyncRequest
 */
export interface SyncRequest {
    /**
     * 
     * @type {string}
     * @memberof SyncRequest
     */
    'id'?: string;
    /**
     * 
     * @type {Array<FilterInfo>}
     * @memberof SyncRequest
     */
    'filters'?: Array<FilterInfo>;
}

/**
 * DashboardServiceApi - axios parameter creator
 * @export
 */
export const DashboardServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardDeleteGet: async (identityToken: string, id?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('dashboardDeleteGet', 'identityToken', identityToken)
            const localVarPath = `/dashboard/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {boolean} [isFinancial] 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardListGet: async (identityToken: string, isFinancial?: boolean, culture?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('dashboardListGet', 'identityToken', identityToken)
            const localVarPath = `/dashboard/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (isFinancial !== undefined) {
                localVarQueryParameter['IsFinancial'] = isFinancial;
            }

            if (culture !== undefined) {
                localVarQueryParameter['culture'] = culture;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {NewRequest} [newRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardNewPost: async (identityToken: string, newRequest?: NewRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('dashboardNewPost', 'identityToken', identityToken)
            const localVarPath = `/dashboard/new`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(newRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [id] 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardRenameGet: async (identityToken: string, id?: string, name?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('dashboardRenameGet', 'identityToken', identityToken)
            const localVarPath = `/dashboard/rename`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardScreenerCategorylistGet: async (identityToken: string, culture?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('dashboardScreenerCategorylistGet', 'identityToken', identityToken)
            const localVarPath = `/dashboard/screener-categorylist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (culture !== undefined) {
                localVarQueryParameter['culture'] = culture;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {SyncRequest} [syncRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardSnycPost: async (identityToken: string, syncRequest?: SyncRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('dashboardSnycPost', 'identityToken', identityToken)
            const localVarPath = `/dashboard/snyc`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syncRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DashboardServiceApi - functional programming interface
 * @export
 */
export const DashboardServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DashboardServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dashboardDeleteGet(identityToken: string, id?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dashboardDeleteGet(identityToken, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {boolean} [isFinancial] 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dashboardListGet(identityToken: string, isFinancial?: boolean, culture?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dashboardListGet(identityToken, isFinancial, culture, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {NewRequest} [newRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dashboardNewPost(identityToken: string, newRequest?: NewRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dashboardNewPost(identityToken, newRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [id] 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dashboardRenameGet(identityToken: string, id?: string, name?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RenameReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dashboardRenameGet(identityToken, id, name, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dashboardScreenerCategorylistGet(identityToken: string, culture?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScreenerCategoryListReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dashboardScreenerCategorylistGet(identityToken, culture, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {SyncRequest} [syncRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dashboardSnycPost(identityToken: string, syncRequest?: SyncRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dashboardSnycPost(identityToken, syncRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DashboardServiceApi - factory interface
 * @export
 */
export const DashboardServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DashboardServiceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardDeleteGet(identityToken: string, id?: string, options?: any): AxiosPromise<DeleteReplay> {
            return localVarFp.dashboardDeleteGet(identityToken, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {boolean} [isFinancial] 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardListGet(identityToken: string, isFinancial?: boolean, culture?: string, options?: any): AxiosPromise<ListReplay> {
            return localVarFp.dashboardListGet(identityToken, isFinancial, culture, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {NewRequest} [newRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardNewPost(identityToken: string, newRequest?: NewRequest, options?: any): AxiosPromise<NewReplay> {
            return localVarFp.dashboardNewPost(identityToken, newRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [id] 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardRenameGet(identityToken: string, id?: string, name?: string, options?: any): AxiosPromise<RenameReplay> {
            return localVarFp.dashboardRenameGet(identityToken, id, name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardScreenerCategorylistGet(identityToken: string, culture?: string, options?: any): AxiosPromise<ScreenerCategoryListReplay> {
            return localVarFp.dashboardScreenerCategorylistGet(identityToken, culture, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {SyncRequest} [syncRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardSnycPost(identityToken: string, syncRequest?: SyncRequest, options?: any): AxiosPromise<SyncReplay> {
            return localVarFp.dashboardSnycPost(identityToken, syncRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DashboardServiceApi - object-oriented interface
 * @export
 * @class DashboardServiceApi
 * @extends {BaseAPI}
 */
export class DashboardServiceApi extends BaseAPI {
    /**
     * 
     * @param {string} identityToken 
     * @param {string} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardServiceApi
     */
    public dashboardDeleteGet(identityToken: string, id?: string, options?: AxiosRequestConfig) {
        return DashboardServiceApiFp(this.configuration).dashboardDeleteGet(identityToken, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {boolean} [isFinancial] 
     * @param {string} [culture] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardServiceApi
     */
    public dashboardListGet(identityToken: string, isFinancial?: boolean, culture?: string, options?: AxiosRequestConfig) {
        return DashboardServiceApiFp(this.configuration).dashboardListGet(identityToken, isFinancial, culture, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {NewRequest} [newRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardServiceApi
     */
    public dashboardNewPost(identityToken: string, newRequest?: NewRequest, options?: AxiosRequestConfig) {
        return DashboardServiceApiFp(this.configuration).dashboardNewPost(identityToken, newRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {string} [id] 
     * @param {string} [name] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardServiceApi
     */
    public dashboardRenameGet(identityToken: string, id?: string, name?: string, options?: AxiosRequestConfig) {
        return DashboardServiceApiFp(this.configuration).dashboardRenameGet(identityToken, id, name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {string} [culture] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardServiceApi
     */
    public dashboardScreenerCategorylistGet(identityToken: string, culture?: string, options?: AxiosRequestConfig) {
        return DashboardServiceApiFp(this.configuration).dashboardScreenerCategorylistGet(identityToken, culture, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {SyncRequest} [syncRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardServiceApi
     */
    public dashboardSnycPost(identityToken: string, syncRequest?: SyncRequest, options?: AxiosRequestConfig) {
        return DashboardServiceApiFp(this.configuration).dashboardSnycPost(identityToken, syncRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * QueryServiceApi - axios parameter creator
 * @export
 */
export const QueryServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {FetchRequest} [fetchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stockfilterFetchdataPost: async (identityToken: string, fetchRequest?: FetchRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('stockfilterFetchdataPost', 'identityToken', identityToken)
            const localVarPath = `/stockfilter/fetchdata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fetchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {string} [stockFilterId] 
         * @param {string} [constituentEntityId] 
         * @param {string} [watchlistId] 
         * @param {boolean} [showFinancial] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stockfilterFetchformulatedataGet: async (identityToken: string, culture?: string, stockFilterId?: string, constituentEntityId?: string, watchlistId?: string, showFinancial?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('stockfilterFetchformulatedataGet', 'identityToken', identityToken)
            const localVarPath = `/stockfilter/fetchformulatedata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (culture !== undefined) {
                localVarQueryParameter['culture'] = culture;
            }

            if (stockFilterId !== undefined) {
                localVarQueryParameter['stockFilterId'] = stockFilterId;
            }

            if (constituentEntityId !== undefined) {
                localVarQueryParameter['constituentEntityId'] = constituentEntityId;
            }

            if (watchlistId !== undefined) {
                localVarQueryParameter['watchlistId'] = watchlistId;
            }

            if (showFinancial !== undefined) {
                localVarQueryParameter['showFinancial'] = showFinancial;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QueryServiceApi - functional programming interface
 * @export
 */
export const QueryServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QueryServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {FetchRequest} [fetchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stockfilterFetchdataPost(identityToken: string, fetchRequest?: FetchRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FetchReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stockfilterFetchdataPost(identityToken, fetchRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {string} [stockFilterId] 
         * @param {string} [constituentEntityId] 
         * @param {string} [watchlistId] 
         * @param {boolean} [showFinancial] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stockfilterFetchformulatedataGet(identityToken: string, culture?: string, stockFilterId?: string, constituentEntityId?: string, watchlistId?: string, showFinancial?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FetchReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stockfilterFetchformulatedataGet(identityToken, culture, stockFilterId, constituentEntityId, watchlistId, showFinancial, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * QueryServiceApi - factory interface
 * @export
 */
export const QueryServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QueryServiceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {FetchRequest} [fetchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stockfilterFetchdataPost(identityToken: string, fetchRequest?: FetchRequest, options?: any): AxiosPromise<FetchReplay> {
            return localVarFp.stockfilterFetchdataPost(identityToken, fetchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {string} [stockFilterId] 
         * @param {string} [constituentEntityId] 
         * @param {string} [watchlistId] 
         * @param {boolean} [showFinancial] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stockfilterFetchformulatedataGet(identityToken: string, culture?: string, stockFilterId?: string, constituentEntityId?: string, watchlistId?: string, showFinancial?: boolean, options?: any): AxiosPromise<FetchReplay> {
            return localVarFp.stockfilterFetchformulatedataGet(identityToken, culture, stockFilterId, constituentEntityId, watchlistId, showFinancial, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QueryServiceApi - object-oriented interface
 * @export
 * @class QueryServiceApi
 * @extends {BaseAPI}
 */
export class QueryServiceApi extends BaseAPI {
    /**
     * 
     * @param {string} identityToken 
     * @param {FetchRequest} [fetchRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueryServiceApi
     */
    public stockfilterFetchdataPost(identityToken: string, fetchRequest?: FetchRequest, options?: AxiosRequestConfig) {
        return QueryServiceApiFp(this.configuration).stockfilterFetchdataPost(identityToken, fetchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {string} [culture] 
     * @param {string} [stockFilterId] 
     * @param {string} [constituentEntityId] 
     * @param {string} [watchlistId] 
     * @param {boolean} [showFinancial] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueryServiceApi
     */
    public stockfilterFetchformulatedataGet(identityToken: string, culture?: string, stockFilterId?: string, constituentEntityId?: string, watchlistId?: string, showFinancial?: boolean, options?: AxiosRequestConfig) {
        return QueryServiceApiFp(this.configuration).stockfilterFetchformulatedataGet(identityToken, culture, stockFilterId, constituentEntityId, watchlistId, showFinancial, options).then((request) => request(this.axios, this.basePath));
    }
}



